import * as React from 'react';

import './style.scss';

interface Props {
  avatar: string;
}

const UserAvatar = (props: Props) => {
  return(
    <img
      className='user-avatar'
      src={props.avatar}
      alt='Avatar' />
  );
};

export default UserAvatar;
